<template>
  <div>
    <form @submit.prevent="getTracking()">
      <b-row>
        <b-col cols="12" lg="6">
          <div class="form-group">
            <label for="search-courier" class="d-inline-block" style="width: 80px;" v-translate>Courier</label>
            <user-autocomplete ref="courierAc" @selected="onSearchCourierSelected" :restrictToRoles="['courier']" with-picture class="d-inline-block w-50" />
          </div>
          <b-form-group class="mt-2">
            <label for="scheduled-at" class="d-inline-block" style="width: 80px;" v-translate>From</label>
            <input type="date" v-model="from" class="form-control" style="width: auto; display: inline-block">
            <b-form-select v-model="fromHour" :options="timeSlots" style="width: auto; display: inline-block" :disabled="allDay">
              <option value="23:59">23:59</option>
            </b-form-select>
             <b-form-checkbox v-model="allDay" style="width: auto; display: inline-block">
              <translate>All Day</translate>
            </b-form-checkbox>
          </b-form-group>
          <b-form-group class="mt-2" v-if="!allDay">
            <label for="scheduled-at" class="d-inline-block" style="width: 80px;" v-translate>To</label>
            <input type="date" v-model="to" class="form-control" style="width: auto; display: inline-block">
            <b-form-select v-model="toHour" :options="timeSlots" style="width: auto; display: inline-block">
              <option value="23:59">23:59</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-card v-if="user">
            <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="user = null; trackingCsv = []; markers = []; heathPath = []; showHeatPath = false; noTrackingData = false">×</span>
            <user-card :user="user" />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button size="sm" variant="secondary" type="submit" :disabled="!formReady || trackingWorking">
            <b-spinner small v-if="trackingWorking" />
            <translate>View</translate>
          </b-button>
          <b-button v-if="trackingCsv.length > 0" size="sm" @click="downloadTrackingCsv" :disabled="trackingWorking"><font-awesome-icon icon="download" /></b-button>
        </b-col>
      </b-row>
    </form>
    <div class="mt-5" v-if="noTrackingData">
      <h2 v-translate>No tracking data for this user into this date range</h2>
    </div>
    <div v-if="user && markers.length > 0" class="mt-3">
      <b-form-checkbox v-model="showHeatPath" :disabled="trackingWorking">
        <translate>Show courier heatPath</translate>
      </b-form-checkbox>
      <leaflet-map :zoom="12" style="width: 100%; height: 500px" ref="fullMap" :fit-always="true" />
    </div>
  </div>
</template>

<script>
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'
import UserCard from '@/components/UserCard'
import LeafletMap from '@/components/LeafletMap'

export default {
  name: 'TrackingHistory',
  components: {
    UserAutocomplete,
    UserCard,
    LeafletMap
  },
  data() {
    return {
      user: null,
      date_from: null,
      date_to: null,
      from: this.moment().format('YYYY-MM-DD'),
      fromHour: '00:00',
      to: this.moment().format('YYYY-MM-DD'),
      toHour: this.moment().format('HH') + ':00',
      timeSlots: Array(23.5 * 2 + 1).fill(1).map((_, i) => {
        return {
          text: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replace(/\d(\d\d)/g, '$1'),
          value: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replace(/\d(\d\d)/g, '$1')
        }
      }),
      allDay: false,
      acOptions: {
        debounce: 500,
        placeholder: this.$gettext('Courier Name or Email'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      searchCourierQuery: '',
      markers: [],
      trackingWorking: false,
      showHeatPath: false,
      noTrackingData: false,
      trackingCsv: []
    }
  },
  computed: {
    formReady() {
      return this.user &&
        this.from &&
        this.fromHour &&
        this.to &&
        this.toHour
    }
  },
  watch: {
    from(val) {
      this.to = val
      this.toHour = '23:59'
    },
    allDay(val) {
      if (val) {
        this.fromHour = '00:00'
        this.to = this.from
        this.toHour = '23:59'
      }
    },
    markers(val) {
      if (val.length === 0 && this.$refs.fullMap) {
        this.$refs.fullMap.addMarkers([])
      }
    },
    showHeatPath(val) {
      if (val) {
        this.$refs.fullMap.addPolylines([])
        this.$refs.fullMap.addHeathPath(this.heathPath)
      } else {
        this.$refs.fullMap.removeHeathPath()
        const polyLines = [{
          polyLine: this.markers,
          polyLineOptions: {strokeColor: '#000000'}
        }]
        this.$refs.fullMap.addPolylines(polyLines)
      }
    }
  },
  methods: {
    onSearchCourierSelected(item) {
      this.user = item
      this.$refs.courierAc.searchQuery = ''
    },
    getTracking() {
      this.trackingWorking = true
      const params = {
        page: 0,
        limit: 1,
        date_from: this.moment(this.from + ' ' + this.fromHour).utc().format('YYYY-MM-DD HH:mm:ss'),
        date_to: this.moment(this.to + ' ' + this.toHour).utc().format('YYYY-MM-DD HH:mm:ss'),
        filter_groups: [
          {
            filters: [
              ['user_id', 'eq', this.user.id]
            ]
          }
        ]
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'tracking-history', {params})
        .then(response => {
          const markers = []
          const trackingCsv = []
          const uniqueTrackingPointsByGeo = response.body.data.filter((thing, index, self) =>
            index === self.findIndex((t) => {
              return thing.lat === t.lat && thing.lng === t.lng
            })
          )
          this.trackingWorking = false

          let timeThreshold = null
          uniqueTrackingPointsByGeo.forEach((item, i) => {
            if (timeThreshold === null || parseInt(item.created_at.replace(/\D/g, '')) > timeThreshold) {
              trackingCsv.push({
                created_at_utc: item.created_at,
                lat: item.lat,
                lng: item.lng,
                user_id: item.user_id
              })
              markers.push({
                id: 1001 + i,
                lat: item.lat,
                lng: item.lng,
                icon: {
                  type: 'marker-circle',
                  size: [10, 10],
                  anchor: [5, 5],
                  color: '#000',
                  text: (i + 1)
                },
                x: 11,
                y: 34,
                infoText: (i + 1) + ': ' + this.moment.utc(item.created_at).tz(this.$tz).format('L LT'),
                tooltip: true,
                z: uniqueTrackingPointsByGeo[(i + 1)] ? this.getSpeed(item, uniqueTrackingPointsByGeo[(i + 1)]) : 0
              })
              timeThreshold = parseInt(item.created_at.replace(/\D/g, '')) + 10
            }
          })
          this.trackingCsv = trackingCsv
          this.markers = markers
          this.heathPath = markers.map(x => {
            return [x.lat, x.lng, x.z]
          })
          if (markers.length > 0) {
            this.noTrackingData = false
            this.showHeatPath = false
            setTimeout(function () {
              this.$refs.fullMap.addMarkers(markers)
              const polyLines = [{
                polyLine: markers,
                polyLineOptions: {strokeColor: '#000000'}
              }]
              this.$refs.fullMap.addPolylines(polyLines)
            }.bind(this, markers), 100)
          } else {
            this.noTrackingData = true
          }
        })
        .catch(error => {
          console.error(error)
          this.trackingWorking = false
        })
    },
    downloadTrackingCsv() {
      let fileName = this.$gettextInterpolate(this.$gettext('Tracking history for courier %{courierId} between %{dateFrom} and %{dateTo}'), {courierId: this.user.id, dateFrom: this.moment(this.from + ' ' + this.fromHour).utc().format('YYYY-MM-DD HH:mm:ss'), dateTo: this.moment(this.to + ' ' + this.toHour).utc().format('YYYY-MM-DD HH:mm:ss')}) + '__' + this.moment().format('YYYYMMDDHHmmss')
      fileName = fileName.toLowerCase().replace(/\s/g, '-') + '.csv'
      this.download(this.toCsv(this.trackingCsv), 'text/csv', fileName)
    }
  }
}
</script>
